import { cva } from "cva";

export const containerStyles = cva({
  base: "mds-container",
  variants: {
    grid: {
      true: "mds-grid",
      false: "",
    },
  },
});
